import Tooltip from "../components/Tooltip.svelte";
import { getRootDocument } from "./Utils";
import { isMobile } from "$/utils/isMobile";
import { get } from "svelte/store";

export function tooltip(node, text) {
    let isMouseOver = false;
    let initialText = text;
    let component;
    let isMobileScreen = get(isMobile);

    function attachTooltip(text) {
        component = new Tooltip({
            target: node,
            props: {
                text: text,
                data: node.getBoundingClientRect(),
            },
        });
    }

    function removeTooltip() {
        component?.$destroy();
        // set to null to avoid memory leak or multiple instances
        component = null;
    }

    function mouseEnterHandler(event) {
        event.stopPropagation();
        removeTooltip();
        isMouseOver = true;
        attachTooltip(initialText);
    }

    node.style.position = "relative";

    if (!isMobileScreen) {
        node.addEventListener("mouseenter", mouseEnterHandler);
        node.addEventListener("mouseleave", () => {
            isMouseOver = false;
            removeTooltip();
        });
        node.addEventListener("click", removeTooltip);
    } else {
        node.addEventListener("touchstart", mouseEnterHandler);
        getRootDocument("web").body.addEventListener(
            "touchstart",
            removeTooltip,
        );
    }

    return {
        update(text) {
            if (initialText !== text && isMouseOver) {
                removeTooltip();
                attachTooltip(text);
            }
            initialText = text;
        },

        destroy() {
            removeTooltip();
            node.removeEventListener("click", removeTooltip);
            node.removeEventListener("mouseenter", mouseEnterHandler);
            node.removeEventListener("mouseleave", removeTooltip);
            node.removeEventListener("touchstart", mouseEnterHandler);
            getRootDocument("web").body.removeEventListener(
                "touchstart",
                removeTooltip,
            );
        },
    };
}
